import { render, staticRenderFns } from "./table-config.vue?vue&type=template&id=3f231194&scoped=true&"
import script from "./table-config.vue?vue&type=script&lang=ts&"
export * from "./table-config.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f231194",
  null
  
)

export default component.exports